export default function(object) {
  return (object && object.constructor && object.constructor.name) || object;
}



// WEBPACK FOOTER //
// ./src/scripts/lib/class_name.js